import { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ gfm: true, breaks: true });

// Links in user content open in a new tab without giving the target a handle on this page.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

/** Renders untrusted markdown (people and agents both write it) as sanitized HTML. */
export function Markdown({ text, className = "md" }: { text: string; className?: string }) {
  const html = useMemo(() => DOMPurify.sanitize(marked.parse(text, { async: false }) as string, { FORBID_TAGS: ["style", "iframe", "form"] }), [text]);
  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}
